module.exports = __webpack_public_path__ + "img/338.f7f0ecd6.svg";